import { Select } from "@mantine/core";
import { type MRT_ColumnDef } from "mantine-react-table-open";
import { Priority, type Todo } from "../../../utils/backend-types";
import { TodosListColumnKeys } from "../TodoTable/TodoTable";

const priorityLabelMapping = {
  [Priority.High]: "Hoch",
  [Priority.Medium]: "Mittel",
  [Priority.Low]: "Niedrig",
  [Priority.Unknown]: "Keine"
};

const priorityFilterData = Object.keys(priorityLabelMapping).map((key) => ({
  value: key,
  label: priorityLabelMapping[key]
}));

export function getPriorityColumn(
  handleChangePriority: (priorityValue: Priority, todoId: number) => void
): MRT_ColumnDef<Todo> {
  return {
    accessorKey: TodosListColumnKeys.Priority,
    header: "Priorität",
    enableGrouping: false,
    Cell: ({ row }) => (
      <Select
        className={"priority-" + row.original.priority}
        data={Object.keys(priorityLabelMapping).map((key) => ({
          value: key,
          label: priorityLabelMapping[key]
        }))}
        value={row.original.priority}
        onChange={(value) =>
          handleChangePriority(value as Priority, row.original.id)
        }
      />
    ),
    filterVariant: "multi-select",
    filterTooltipValueFn: (value) => priorityLabelMapping[value],
    mantineFilterMultiSelectProps: {
      data: priorityFilterData,
      searchable: false,
      dropdownOpened: true
    }
  };
}
